module.exports = __webpack_public_path__ + "static/media/slider_tractocamion.5c50b394.png";